<div class="permissions-dialog">
  <div class="permissions-dialog-info">
    <div class="permissions-dialog-icon" [ngClass]="{ 'desktop-icon': canEnable }">
      <svg-icon *ngIf="canEnable" src="/assets/icons/desktop-circle.svg"></svg-icon>
      <svg-icon *ngIf="!canEnable" src="/assets/icons/alert-circle.svg"></svg-icon>
    </div>
    {{ description }}
    <button *ngIf="canEnable" class="button button-reverse button-pill" (click)="enableNotifications()">Turn On</button>
  </div>
</div>
